import * as Sentry from '@sentry/nextjs'
import mixpanel from 'mixpanel-browser'

import { appInitFailed } from '@/constants/sentry-type'
import { AppDispatch } from '@/redux'
import { readMineEmployee } from '@/redux/employee-actions'
import { readAllFunctionPermissions } from '@/redux/function-permission'
import {
  defaultFeatureKeys,
  setInitializing,
  setIsLogin,
} from '@/redux/global'
import { readAllGroups } from '@/redux/group'
import { readAllMenus } from '@/redux/menu'
import {
  readAllRoles,
  readMineRoles,
} from '@/redux/role'
import { readSalesSettingsHistory, readActivatedSalesSettings } from '@/redux/sales-settings'
import { getValidToken } from '@/utils/auth'
import { onCurrentEmployeeEmailChange } from '@/utils/env'

export const init = async (dispatch: AppDispatch) => {
  dispatch(setInitializing(true))
  try {
    const { idToken } = await getValidToken()
    if (!idToken) {
      dispatch(setInitializing(false))
      return
    }
    dispatch(setIsLogin(true))

    const { id, name, email } = await dispatch(readMineEmployee()).unwrap()
    Sentry.setUser({
      id,
      name,
      email,
    })
    mixpanel.identify(id.toString())
    mixpanel.people.set({ '$email': email, '$name': name })
    mixpanel.track_pageview({
      page: defaultFeatureKeys,
    })
    onCurrentEmployeeEmailChange(email)

    await Promise.all([
      dispatch(readAllGroups()).unwrap(),
      dispatch(readMineRoles()).unwrap(),
      dispatch(readAllRoles()).unwrap(),
      dispatch(readAllMenus()).unwrap(),
      dispatch(readSalesSettingsHistory({})).unwrap(),
      dispatch(readActivatedSalesSettings()).unwrap(),
      dispatch(readAllFunctionPermissions()).unwrap(),
    ])
  } catch (e) {
    Sentry.withScope((scope) => {
      scope.setTags({ type: appInitFailed })
      scope.captureException(e)
    })
  }
  dispatch(setInitializing(false))
}
